module.exports = __webpack_public_path__ + "static/img/logo@2x.b9e19cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/menu/logo@2x.png
// module id = pS+/
// module chunks = 1